<template>
  <div>
    <div class="artcol_top_bar">
      <span v-if="showButton" class="artcol_tip artcol_tip_noac" @click="goTome"
        >个人中心</span
      >
      <span
        v-else
        class="artcol_tip artcol_tip_noac"
        @click="goToArticleCollection"
        >文章收藏</span
      >
      <i class="el-icon-arrow-right"></i>
      <span
        v-if="showButton"
        class="artcol_tip artcol_tip_noac"
        @click="goToArtmag"
        >文章管理</span
      >
      <span v-else class="artcol_tip artcol_tip_noac" @click="goToArticlePre"
        >文章预览</span
      >
      <i class="el-icon-arrow-right"></i>
      <span
        v-if="showButton"
        class="artcol_tip artcol_tip_noac"
        @click="goToArticleDetail(articleId, source, selected_tags, createTime)"
        >文章详情</span
      >
      <span v-else class="artcol_tip" @click="goToArticleEdit">文章编辑</span>
      <i v-if="showButton" class="el-icon-arrow-right"></i>
      <span v-if="showButton" class="artcol_tip" @click="goToArticleEdit"
        >文章编辑</span
      >
    </div>

    <div class="line_con">
      <span class="txt_label">文章分类：</span>
      <div class="add_in_con1 type_ses_con">
        <div class="type_ses_left_con">
          <select
            class="el-dropdown-link_left"
            :value="firstLevelClassId"
            @change="changeFirstLevelClass"
          >
            <option
              v-for="item in firstLevelClass"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>

          <select
            class="el-dropdown-link_right"
            :value="secondLevelClassId"
            @change="changeSecondLevelClass"
          >
            <option
              v-for="item in curSecondLevelClassCandidates"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">文章标签：</span>
      <div class="label_con">
        <div
          class="out_label"
          :class="{ selected_up: tag.isselected_up }"
          v-for="(tag, idx) in tags"
          :key="tag.labelId"
          @click="toggleTag(idx)"
        >
          <div class="inlabel">{{ tag.labelName }}</div>
        </div>

        <el-popover
          v-model="addTagPopoverVisible"
          placement="bottom"
          trigger="click"
        >
          <el-input v-model="addTagInputValue" placeholder="新标签名" />
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="addTagPopoverVisible = false"
              >取消
            </el-button>
            <el-button type="primary" size="mini" @click="addTagHandler"
              >确定
            </el-button>
          </div>
          <el-button style="margin-left: 10px" slot="reference"
            >添加标签
          </el-button>
        </el-popover>
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">文章标题：</span>
      <div class="add_in_con">
        <i class="el-icon-tickets"></i>
        <input
          class="add_in"
          placeholder="请输入文章标题"
          v-model="articleTitle"
        />
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">文章来源：</span>
      <div class="add_in_con">
        <i class="el-icon-copy-document"></i>
        <input
          disabled
          class="add_in"
          placeholder="请输入文章来源"
          v-model="source"
        />
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">发布时间：</span>
      <div class="add_in_con">
        <i class="el-icon-watch"></i>
        <input
          disabled
          class="add_in"
          placeholder="请输入发布时间"
          :value="createTime"
        />
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">收藏时间：</span>
      <div class="add_in_con">
        <i class="el-icon-timer"></i>
        <input
          disabled
          class="add_in"
          placeholder="请输入收藏时间"
          :value="collectionTime"
        />
      </div>
    </div>

    <div class="line_con" v-if="showEditor">
      <span class="txt_label">正&emsp;&emsp;文：</span>
      <div class="add_in_con2">
        <VueUeditorWrap v-model="content" :config="myConfig" />
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">附件上传：</span>
      <div class="add_in_con">
        <el-upload
          class="upload-demo"
          accept=".jpg,.png,.pdf,.doc,.docx"
          :action="upload_url"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          multiple
          :limit="3"
          :headers="dynamicHeaders"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-button
            size="small"
            type="primary"
            style="display: block !important"
            >点击上传
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png/pdf/doc/docx文件
          </div>
        </el-upload>
      </div>
    </div>

    <div class="btns_con">
      <button class="save_btn" @click="cancel()">取 消</button>
      <button class="save_btn" @click="save()">保存修改</button>
    </div>
  </div>
</template>

<script>
import {
  GetFirstLevelClassification,
  updateKpArticle,
  GetSecondLevelClassification,
  saveArticle,
  apiAddTag,
} from "@/api/article";
import VueUeditorWrap from "vue-ueditor-wrap";
import { url } from "@/api/request";
import { mapState } from "vuex";

export default {
  name: "art-edit",
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      dynamicHeaders: null,
      userId: 1,
      fileList: [],
      articleId: "",
      articleTitle: "",
      articleType: "",
      content: "",
      html: "",
      source: "",
      createTime: "2023",
      collectionTime: "2024-03-05 00:00:00",
      index: 1,
      upload_url: `${url}/api/kp/article/startUploadList`,
      showButton: false,
      showEditor: true,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: "200%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: `${url}/kp/ueditor`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/ueditor/",
      },
      addTagInputValue: "",
      addTagPopoverVisible: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },

    articleInfo() {
      return this.$store.getters.getArticleInfo;
    },

    selected_tags() {
      return this.articleInfo.tags.filter((tag) => {
        return tag.isselected_up;
      });
    },

    ...mapState({
      tags: (state) => state.article.tags,
      firstLevelClass: (state) => state.article.firstLevelClass,
      allSecondLevelClass: (state) => state.article.allSecondLevelClass,
      firstLevelClassId: (state) => state.article.firstLevelClassId,
      secondLevelClassId: (state) => state.article.secondLevelClassId,
    }),

    curSecondLevelClassCandidates() {
      const candidates = this.allSecondLevelClass.filter(
        (item) => item.parentId === this.firstLevelClassId
      );
      this.$store.commit("CHANGE_ARTICLE_SECOND_CLASS", candidates[0].sortId);
      return candidates;
    },
  },
  mounted() {
    this.$store.dispatch("getClassifications");
    console.log(this.$store.getters.getArticleInfo);
    if (!this.articleInfo.articleTitle) {
      this.$router.push({
        name: "artcol",
        params: {},
      });
    }
    if (this.$route.params.artdetail) {
      this.showButton = true;
    }
    if (this.$route.params.articleSource === "本地上传") {
      this.showEditor = false;
    }
    this.dynamicHeaders = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    this.firstLevelClassId = this.articleInfo.firstLevelClassId;
    this.secondLevelClassId = this.articleInfo.secondLevelClassId;
    this.firstLevelClass = this.articleInfo.firstLevelClass;
    this.secondLevelClass = this.articleInfo.secondLevelClass;
    this.articleId = this.articleInfo.articleId;
    this.articleTitle = this.articleInfo.articleTitle;
    this.articleType = this.articleInfo.articleType;
    this.content = this.articleInfo.content;
    this.html = this.articleInfo.html;
    this.source = this.articleInfo.source || "微信";
    this.createTime = this.articleInfo.createTime || "2001-00-00 00:00:00";
    this.collectionTime =
      this.articleInfo.collectionTime || "2000-00-00 00:00:00";
    this.userId = this.articleInfo.userId;
    this.fileList = this.articleInfo.fileList || [];

    // 创建一个包含两个 promise 的数组
    Promise.all([
      GetFirstLevelClassification({
        userId: this.userInfo.id || 1,
      }),
      GetSecondLevelClassification({
        userId: this.userInfo.id || 1,
      }),
    ])
      .then((responses) => {
        responses[0].data.forEach((item) => {
          if (item.sortId == this.firstLevelClassId) {
            this.firstLevelClass = item.sortName;
            console.log(item.sortName);
          }
        });
        console.log("GetSecondLevelClassification Response:", responses[1]);
        responses[1].data.forEach((item) => {
          if (item.sortId == this.secondLevelClassId) {
            this.secondLevelClass = item.sortName;
          }
        });
      })
      .catch((error) => {
        // 处理任一 promise 出错的情况
        console.error("Error in one of the promises:", error);
      });
  },
  methods: {
    goToArticleDetail(articleId, source, kpArticleLabels, createTime) {
      this.$router.push({
        name: "artdetail",
        query: {
          aid: articleId,
          asource: source,
          akpArticleLabels: kpArticleLabels,
          acreateTime: createTime,
        },
      });
    },
    goToArtmag() {
      this.$router.push({ name: "artmag" });
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
    goToArticleCollection() {
      this.$router.push({
        name: "artcol",
      });
    },
    goToArticlePre() {
      this.$router.push({
        name: "artpre",
      });
    },
    goToArticleEdit() {
      this.$router.push({
        name: "artedit",
      });
    },
    kindeditorChange(val) {
      console.log(val);
    },
    handleSuccess(response, file, fileList) {
      this.$store.dispatch("recordData", {
        ...this.articleInfo,
        fileList,
      });
      console.log(this.articleInfo.fileList);
      this.fileList = fileList;
      this.loading.close();
    },
    handleRemove(file, fileList) {
      this.$store.dispatch("recordData", {
        ...this.articleInfo,
        fileList,
      });
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    back() {
      this.$router.push({
        name: "artcol",
        params: {},
      });
    },
    toggleTag(idx) {
      this.$store.commit("TOGGLE_TAG", idx);
    },
    changeFirstLevelClass(e) {
      const curFirstLevelId = Number(e.target.value);
      this.$store.commit("CHANGE_ARTICLE_FIRST_CLASS", curFirstLevelId);
    },
    changeSecondLevelClass(e) {
      const curSecondLevelId = Number(e.target.value);
      this.$store.commit("CHANGE_ARTICLE_SECOND_CLASS", curSecondLevelId);
    },
    preview() {
      var that = this;

      that.$router.push({
        name: "artpre",
        params: {
          refresh: true,
        },
      });
    },
    getFormData() {
      return {
        articleTitle: this.articleTitle,
        articleType: this.articleType,
        source: this.source,
        createTime: this.createTime,
        saveTime: this.saveTime,
        content: this.content,
        html: this.html,
        selected_tags: this.selected_tags,
        url: this.url,
        firstLevelClassId: this.firstLevelClassId,
        secondLevelClassId: this.secondLevelClassId,
        collectionTime: this.collectionTime,
        collectionProcess: this.collectionProcess,
        articleId: this.articleInfo.articleId,
        uploadUrl: this.articleInfo.uploadUrl,
      };
    },
    /**
     * 保存文章
     */
    save() {
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "正在修改文章...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        target: ".main_right",
      });
      this.fileNameList = [];
      if (this.articleInfo.fileList) {
        for (const x of this.articleInfo.fileList) {
          console.log("++++++++++++++++++++++++");
          if (x.raw) this.fileNameList.push(x.raw.name);
          else if (x.name) this.fileNameList.push(x.name);
        }
      }
      console.log(this.fileNameList);
      console.log("#################");
      console.log(this.selected_tags);
      saveArticle({
        articleId: this.articleId,
        articleTitle: this.articleTitle,
        articleType: this.articleType,
        content: this.content,
        html: this.html,
        collectionTime: this.collectionTime,
        firstSortId: this.firstLevelClassId,
        publishTime: this.createTime,
        secondSortId: this.secondLevelClassId,
        source: this.source,
        tagList: this.selected_tags,
        url: this.url,
        userId: this.userInfo.id,
        fileNameList: this.fileNameList || [],
      })
        .then((res) => {
          console.log(res);
          this.$message.success("修改文章成功");
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("修改文章失败");
        })
        .finally(() => {
          loading.close();
        });
      this.$store.dispatch("clearData");

      this.$router.push({
        name: "artcol",
        params: {
          clearDataBoolean: true,
          refresh: true,
        },
      });
    },
    cancel() {
      this.$router.push({
        name: "artpre",
        params: {
          refresh: true,
        },
      });
    },
    beforeUpload(file) {
      var fileName = file.name;
      var fileType = fileName.substring(fileName.lastIndexOf("."));
      console.log(file);
      if (
        fileType !== ".jpg" &&
        fileType !== ".png" &&
        fileType !== ".pdf" &&
        fileType !== ".doc" &&
        fileType !== ".docx"
      ) {
        this.$message.error({
          message: `请上传jpg/png/pdf/doc/docx文件！`,
        });
        return false;
      }
      this.loading = this.$loading({
        lock: true,
        text: "正在上传附件...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
    },
    addTagHandler() {
      if (this.addTagInputValue === "") {
        this.$message.error("新标签名不能为空");
        return;
      }
      const data = {
        labelId: NaN,
        labelName: this.addTagInputValue,
      };
      apiAddTag(data)
        .then((res) => {
          const labelId = res.data.labelId;
          this.$store.commit("ADD_TAG", {
            labelId,
            labelName: this.addTagInputValue,
            isselected_up: true,
          });
        })
        .finally(() => {
          this.addTagPopoverVisible = false;
          this.addTagInputValue = "";
        });
    },
  },
};
</script>

<style>
.save_btn {
  background-image: url("../assets/save.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 60px;
}

.preview_btn {
  background-image: url("../assets/yulan.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.btns_con {
  margin-top: 60px;
  width: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inlabel {
  margin: 2px;
  background-color: #007ec3;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 16px;
  color: #fff6d5;
  white-space: nowrap;
}

.out_label {
  border: solid 1px #008a9d;
  background-color: #fff6d5;
  cursor: pointer;
  margin-left: 10px;
}

/* 选中标签的样式 */
.selected_up {
  color: #2f8dc0;
  background-color: #2f8dc0;
  border-right: 3px solid #2f8dc0; /* 深蓝色边框 */
  padding: 5px 10px; /* 增加内边距 */
  border-radius: 5px; /* 圆角 */
  transition:
    background-color 0.3s,
    border-color 0.3s; /* 平滑过渡 */
}

.label_con {
  display: flex;
  align-items: center;
}

.el-dropdown-link_right {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  margin-right: 10px;
  font-size: 18px;
}

.el-dropdown-link_left {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  font-size: 18px;
  margin-right: 10px;
}

.type_ses_left_con {
  flex-grow: 2;
  display: flex;
  align-items: center;
}

.add_img {
  width: 21px;
  height: 21px;
}

.type_ses_con {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
  width: 450px;
}

.add_in::placeholder {
  font-size: 18px;
  color: #999999;
}

.add_in:focus {
  outline: none;
}

.add_in_con1 {
  width: 465px;
}

.add_in_con2 {
  width: 600px;
}

.add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.txt_label {
  color: #333333;
  font-size: 18px;
  font-weight: 550;
  white-space: nowrap;
}

.line_con {
  margin-top: 30px;
  display: flex;
  align-items: center;
}

.artcol_tip {
  font-size: 18px;
  color: #2683be;
}

.artcol_tip_noac {
  color: #999999 !important;
}

.artcol_top_bar {
  display: flex;
  align-items: center;
}
</style>
